import React, { useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';
import Header from '@nextiva/global-header__simple-header';
import { connect, useSelector } from 'react-redux';
import { dataSelector } from '@nextiva/global-store';
import { Alert, styled } from '@nextiva/next-ui-components';
import clsx from 'clsx';
import { FeatureContext } from 'components/AccessResolvers/featureContext';

import { useGetInfo } from 'hooks/infoService';
import breadcrumbsConfig, { getBreadcrumbs } from '../../breadcrumbs.config';
import Breadcrumbs from './Breadcrumbs';
import styles from './Header.scss';
import './v2Header.scss';

const widgets = {
  calendar: null,
};

const BUY_LICENSES_BANNER_TEXT =
  'Need more licenses? Hover over a row and select Purchase licenses from the Actions menu';
const LICENSE_PAGE_TITLE = 'Licensing';

const StyledAlert = styled(Alert)`
  margin-bottom: 28px;
`;

function AdminHeader({
  children,
  globalStoreData,
  history,
  pageMeta: {
    title,
    isHomePage,
    isTabs = false,
    titleComponent,
    noPermissionLicense,
    withPageHeader = true,
    withContentWrapper = true,
  },
}) {
  const {
    featureState: { authV3Enabled, globalNavigation, purchaseLicenseFlow },
  } = useContext(FeatureContext);
  const { data: user } = useGetInfo();
  const [showLicenseBanner, setShowLicenseBanner] = useState(true);

  const purchaseLicenseFlowGrantStatus = useSelector(
    (state) =>
      state.globalPolicyDecisionRequestState.purchaseLicenseFlowGrantStatus,
  );
  const accountV2Summary = useSelector(
    (state) => state.globalAccountV2SummaryState.globalAccountV2Summary,
  );

  const firstName = authV3Enabled ? user?.firstName : user?.first_name;
  const lastName = authV3Enabled ? user?.lastName : user?.last_name;
  const inAppPurchaseEnabled =
    accountV2Summary?.attributes?.inAppPurchaseEnabled === 'true' ||
    accountV2Summary?.attributes?.inAppPurchaseEnabled === true;
  const freemiumFlowEnabled =
    accountV2Summary?.attributes?.freemium === 'true' ||
    accountV2Summary?.attributes?.freemium === true;
  const isPurchaseLicenseFlowEnabled =
    purchaseLicenseFlow &&
    inAppPurchaseEnabled &&
    purchaseLicenseFlowGrantStatus &&
    !freemiumFlowEnabled;

  const { location } = history;
  const showAdminHeader = !getBreadcrumbs(location.pathname, breadcrumbsConfig);
  const headerClassName = isHomePage ? 'HomePage' : 'root';

  return (
    <>
      <div className={styles.headerContainer}>
        <div className={styles[headerClassName]}>
          <Header
            className={styles.appHeader}
            appName={
              globalNavigation ? 'Administration' : 'Administration Tools'
            }
            firstName={firstName}
            lastName={lastName}
            isLoading={false}
            isHeaderLogoVisible={isHomePage}
            widgets={widgets}
            globalStoreData={globalStoreData}
          />
          <Breadcrumbs
            className="paAdminHeader__breadcrumbs"
            config={breadcrumbsConfig}
            pathname={location.pathname}
          />
          {withPageHeader && showAdminHeader && (
            <div
              className={clsx(
                'paAdminHeader',
                title === 'Data import' && 'paAdminHeader__header',
              )}
            >
              {title === LICENSE_PAGE_TITLE &&
                showLicenseBanner &&
                !noPermissionLicense &&
                isPurchaseLicenseFlowEnabled && (
                  <StyledAlert
                    fullWidth
                    severity="info"
                    onClose={() => setShowLicenseBanner(false)}
                  >
                    {BUY_LICENSES_BANNER_TEXT}
                  </StyledAlert>
                )}
              <div
                className={clsx(
                  isTabs
                    ? 'paAdminHeader__title__tabs'
                    : 'paAdminHeader__title',
                  title === 'Data import' && 'paAdminHeader__header__title',
                )}
                data-testid="PlatformAdminUI-AccountInfo-Header-Title"
              >
                {titleComponent || title}
              </div>
            </div>
          )}
        </div>
      </div>
      <div
        className={clsx(
          withContentWrapper && styles.content,
          title === 'Data import' && styles.importContent,
        )}
      >
        {children}
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({
  globalStoreData: dataSelector(state),
  pageMeta: state.pageMeta,
});

export default connect(mapStateToProps)(withRouter(AdminHeader));
